import React from 'react';
import type { SVGProps } from 'react';

// Import/export all the icons in this file
//admin panel pages
import Clients from 'assets/icons/clients.svg?react';
import Users from 'assets/icons/users.svg?react';
import Profile from 'assets/icons/profile.svg?react';
//user panel pages
import Home from 'assets/icons/home.svg?react';
import Reports from 'assets/icons/reports.svg?react';
import MyFiles from 'assets/new-icons/my-files.svg?react';

//learn section
import BrokenLink from 'assets/icons/broken-link.svg?react';
import Trophy from 'assets/new-icons/trophy.svg?react';

//categories
import DataAnalysis from 'assets/new-icons/learn-nav/categories/data-analisis.svg?react';
import Optimizing from 'assets/new-icons/learn-nav/categories/optimazing.svg?react';
import AdvancedAnalytics from 'assets/new-icons/learn-nav/categories/advanced-analitics.svg?react';
import DataVisualization from 'assets/new-icons/learn-nav/categories/data-visualization.svg?react';
import Collaboration from 'assets/new-icons/learn-nav/categories/collaboration.svg?react';
//content
import Articles from 'assets/new-icons/learn-nav/content/articles.svg?react';
import Guides from 'assets/new-icons/learn-nav/content/guides.svg?react';
import Downloads from 'assets/new-icons/learn-nav/content/downloads.svg?react';
import Webinars from 'assets/new-icons/learn-nav/content/webinars.svg?react';
import ProductAnnouncements from 'assets/new-icons/learn-nav/content/product-announcements.svg?react';
import Glossary from 'assets/new-icons/learn-nav/content/glossary.svg?react';
import Courses from 'assets/new-icons/learn-nav/content/courses.svg?react';
import Like from 'assets/new-icons/thumb-up.svg?react';
import QuoteMark from 'assets/new-icons/quote-mark.svg?react';
import Calendar from 'assets/new-icons/calendar.svg?react';
import OpenBook from 'assets/new-icons/book-open.svg?react';
//notifications
import Info from 'assets/new-icons/info.svg?react';
import Success from 'assets/new-icons/success.svg?react';
import Warning from 'assets/new-icons/warning.svg?react';
//actions
import Search from 'assets/icons/search.svg?react';
import Edit from 'assets/new-icons/edit.svg?react';
import Delete from 'assets/new-icons/delete.svg?react';
import Close from 'assets/new-icons/close.svg?react';
import Plus from 'assets/icons/plus.svg?react';
import Rotate from 'assets/icons/rotate.svg?react';
import Upload from 'assets/new-icons/upload.svg?react';
import Download from 'assets/new-icons/download.svg?react';
import Camera from 'assets/new-icons/camera.svg?react';
import LogOut from 'assets/new-icons/log-out.svg?react';
import Assign from 'assets/new-icons/assign.svg?react';
import Unassign from 'assets/new-icons/unassign.svg?react';

//labels
import Active from 'assets/new-icons/active-status.svg?react';
import Expired from 'assets/new-icons/expired-status.svg?react';
import Hidden from 'assets/new-icons/hidden-status.svg?react';
import Archived from 'assets/new-icons/archive.svg?react';
import Lock from 'assets/new-icons/lock.svg?react';
import Link from 'assets/new-icons/link.svg?react';
//images
import Logo from 'assets/images/marketview-logo.svg?react';
import LoginLogo from 'assets/images/mv-login-logo.svg?react';
import FullLogo from 'assets/images/marketview-full-logo.svg?react';
import SmallLogo from 'assets/images/mv-small-logo.svg?react';
import EmptyImageAll from 'assets/images/empty-image-all.svg?react';
import EmptyImage from 'assets/images/empty-image.svg?react';
import Caution from 'assets/images/caution.svg?react';
import Security from 'assets/images/security-hub.svg?react';
import GetStartedGuide from 'assets/images/get-started-guide.svg?react';
//doc types
import DocFile from 'assets/new-icons/file-types/doc-file.svg?react';
import PdfFile from 'assets/new-icons/file-types/pdf-file.svg?react';
import PptFile from 'assets/new-icons/file-types/ppt-file.svg?react';
import XlsFile from 'assets/new-icons/file-types/xls-file.svg?react';
import DefaultFile from 'assets/new-icons/file.svg?react';
//table icons
import Details from 'assets/new-icons/details.svg?react';
import Eye from 'assets/new-icons/eye.svg?react';
import CellInfo from 'assets/new-icons/info-2.svg?react';
import DefaultSort from 'assets/new-icons/table-header-icon.svg?react';
import Sort from 'assets/new-icons/sort-up.svg?react';
import Columns from 'assets/new-icons/columns.svg?react';
//Goals
import ArrowUp from 'assets/new-icons/goals/arrow-up-circle.svg?react';
import ArrowDown from 'assets/new-icons/goals/arrow-down-circle.svg?react';
import PlusInCircle from 'assets/new-icons/goals/plus-in-circle.svg?react';
import EditPencil from 'assets/new-icons/goals/edit-pencil.svg?react';
import Maintain from 'assets/new-icons/goals/maintain.svg?react';
import XinCircle from 'assets/new-icons/goals/x-circle.svg?react';
import Ai from 'assets/new-icons/goals/ai.svg?react';
//Widgets
import Target from 'assets/new-icons/widgets/target.svg?react';

//Reports
import Learn from 'assets/new-icons/reports/learn.svg?react';
import Finance from 'assets/new-icons/reports/finance.svg?react';
import People from 'assets/new-icons/reports/people.svg?react';
import ProspectViewFunnel from 'assets/new-icons/reports/funnel.svg?react';
import AllReports from 'assets/new-icons/reports/all-reports.svg?react';
import Star from 'assets/new-icons/reports/star.svg?react';

//Insights
import Idea from 'assets/new-icons/insights/idea.svg?react';
import Chart from 'assets/new-icons/insights/chart.svg?react';

//other
import Arrow from 'assets/icons/angle-right.svg?react';
import DoubleArrow from 'assets/icons/double-angle-right.svg?react';
import ChevronRight from 'assets/icons/chevron-right.svg?react';
import ChevronLeft from 'assets/icons/chevron-left.svg?react';
import ChevronDown from 'assets/icons/angle-down.svg?react';
import ArrowUpRight from 'assets/icons/arrow-up-right.svg?react';
import ArrowDownRight from 'assets/icons/arrow-down-right.svg?react';
import CircleDotted from 'assets/icons/circle-dotted.svg?react';
import Help from 'assets/icons/help.svg?react';
import Settings from 'assets/icons/settings.svg?react';
import Spinner from 'assets/icons/loading.svg?react';
import RequiredIndicator from 'assets/new-icons/required-indicator.svg?react';
import Burger from 'assets/new-icons/learn-nav/burger.svg?react';
import Check from 'assets/new-icons/check.svg?react';
import CheckOld from 'assets/icons/check 2.svg?react';
import CheckCircle from 'assets/icons/check-circle.svg?react';
import Product from 'assets/new-icons/product.svg?react';
import OutlinedMinus from 'assets/new-icons/outlined-minus.svg?react';
import OutlinedPlus from 'assets/new-icons/outlined-plus.svg?react';
import Gear from 'assets/icons/gear.svg?react';
import ArrowDownIndicator from 'assets/new-icons/arrow-down-indicator.svg?react';
import ArrowUpIndicator from 'assets/new-icons/arrow-up-indicator.svg?react';
import Insight from 'assets/icons/insight.svg?react';
import Steps from 'assets/icons/steps.svg?react';
import Monitoring from 'assets/new-icons/monitoring.svg?react';
import Puzzle from 'assets/new-icons/puzzle.svg?react';
import MoreVertical from 'assets/icons/more-vertical.svg?react';

//Aid studio
import AidStudio from 'assets/new-icons/aid-studio/aid-studio.svg?react';
import Refresh from 'assets/new-icons/aid-studio/refresh.svg?react';
import GripVertical from 'assets/new-icons/aid-studio/grip-vertical.svg?react';
import Grip from 'assets/new-icons/aid-studio/grip.svg?react';
import FilterIcon from 'assets/new-icons/filter-icon.svg?react';
import Checklist from 'assets/new-icons/aid-studio/checklist.svg?react';
import Layers from 'assets/new-icons/aid-studio/layers.svg?react';
import Undo from 'assets/new-icons/aid-studio/undo.svg?react';
import Release from 'assets/new-icons/aid-studio/release.svg?react';

//AI assistant
import MarkIcon from 'assets/new-icons/ai-assistant/mark-icon.svg?react';
import MarkLogo from 'assets/new-icons/ai-assistant/mark-logo.svg?react';
import Retry from 'assets/new-icons/ai-assistant/retry.svg?react';
import Copy from 'assets/new-icons/ai-assistant/copy.svg?react';
import Clock from 'assets/new-icons/clock.svg?react';
import History from 'assets/new-icons/history.svg?react';
import PlusThin from 'assets/new-icons/plus-thin.svg?react';
import ThumbsUp from 'assets/new-icons/ai-assistant/thumbs-up.svg?react';
import ThumbsDown from 'assets/new-icons/ai-assistant/thumbs-down.svg?react';
import ThumbsUpFilled from 'assets/new-icons/ai-assistant/thumbs-up-filled.svg?react';
import ThumbsDownFilled from 'assets/new-icons/ai-assistant/thumbs-down-filled.svg?react';
import AiSidebarLeft from 'assets/new-icons/ai-assistant/ai-sidebar-left.svg?react';
import AiChatNew from 'assets/new-icons/ai-assistant/ai-chat-new.svg?react';
import BarChartHorizontal from 'assets/new-icons/ai-assistant/bar-chart-horizontal.svg?react';
import BarChartAscending from 'assets/new-icons/ai-assistant/bar-chart-ascending.svg?react';
import Table from 'assets/new-icons/ai-assistant/table.svg?react';
import LineGraph from 'assets/new-icons/line-graph.svg?react';
import ChartsVerticalBar from 'assets/new-icons/charts-vertical-bar.svg?react';
import Funnel from 'assets/new-icons/funnel.svg?react';
import Profile2 from 'assets/new-icons/profile-2.svg?react';

type RawIcon = React.ComponentType<SVGProps<SVGSVGElement>>;
type BoxedIconProps = SVGProps<SVGSVGElement> & {
  customClass?: string;
};

const icons = {
  //admin panel pages
  Clients,
  Users,
  Profile,
  //user panel pages
  Home,
  Reports,
  MyFiles,
  //learn section
  BrokenLink,
  Trophy,
  //categories
  DataAnalysis,
  Optimizing,
  AdvancedAnalytics,
  DataVisualization,
  Collaboration,
  //content
  Articles,
  Guides,
  Downloads,
  Webinars,
  ProductAnnouncements,
  Glossary,
  Courses,
  Like,
  QuoteMark,
  Calendar,
  OpenBook,
  //notifications
  Info,
  Success,
  Warning,
  //actions
  Search,
  Edit,
  Delete,
  Close,
  Plus,
  Rotate,
  Upload,
  Download,
  Camera,
  LogOut,
  Assign,
  Unassign,
  //labels
  Active,
  Expired,
  Hidden,
  Archived,
  Lock,
  Link,
  //images
  Logo,
  LoginLogo,
  FullLogo,
  SmallLogo,
  EmptyImageAll,
  EmptyImage,
  Caution,
  Security,
  GetStartedGuide,
  //doc types
  DocFile,
  PdfFile,
  PptFile,
  XlsFile,
  DefaultFile,
  //table icons
  Details,
  Eye,
  CellInfo,
  DefaultSort,
  Sort,
  Columns,
  //Goals
  ArrowUp,
  ArrowDown,
  PlusInCircle,
  EditPencil,
  Maintain,
  XinCircle,
  Ai,
  //Widgets
  Target,
  //Reports
  Learn,
  Finance,
  People,
  ProspectViewFunnel,
  AllReports,
  Star,
  //other
  Arrow,
  DoubleArrow,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  ArrowUpRight,
  ArrowDownRight,
  CircleDotted,
  Help,
  Settings,
  Spinner,
  RequiredIndicator,
  Burger,
  Check,
  CheckOld,
  CheckCircle,
  Product,
  OutlinedMinus,
  OutlinedPlus,
  Gear,
  ArrowDownIndicator,
  ArrowUpIndicator,
  Insight,
  Steps,
  Monitoring,
  Puzzle,
  MoreVertical,
  //Insights
  Idea,
  Chart,
  //Aid studio
  AidStudio,
  Refresh,
  GripVertical,
  Grip,
  FilterIcon,
  Checklist,
  Layers,
  Undo,
  Release,
  //AI assistant
  MarkIcon,
  MarkLogo,
  Retry,
  Copy,
  Clock,
  History,
  PlusThin,
  ThumbsUp,
  ThumbsDown,
  ThumbsUpFilled,
  ThumbsDownFilled,
  AiSidebarLeft,
  AiChatNew,
  BarChartHorizontal,
  BarChartAscending,
  Table,
  LineGraph,
  ChartsVerticalBar,
  Funnel,
  Profile2,
} satisfies Record<string, RawIcon>;

// Wrap our icons in Boxes so we can use our color/space classes.
const boxedIcons = Object.entries(icons).reduce<Record<string, React.FC<BoxedIconProps>>>((result, [icon, Icon]) => {
  result[icon] = ({ customClass = '', onClick, ...rest }) =>
    React.createElement(Icon, {
      className: `block ${customClass}`,
      onClick,
      ...rest,
    });

  return result;
}, {});

export default boxedIcons;
